import React from "react";
import { Box, Container, Divider, makeStyles } from "@material-ui/core";
import { Page, FooterSmall, OtherServices } from "@packages/ui";
import getBrandFromUrl from "../../utils/getBrandFromUrl";
import * as constants from "../../utils/constants";
import LoginForm from "../../components/LoginForm";
import getServiceFromUrl from "../../utils/getServiceFromUrl";
import getCountryFromURL from "src/utils/getCountryFromUrl";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
  },
  tile: {
    width: "100%",
  },
  container: {
    backgroundColor: "white",
    paddingTop: 35,
    paddingBottom: 20,
    borderRadius: 5,
    [theme.breakpoints.up("xs")]: { border: "none", borderRadius: 0 },
    [theme.breakpoints.up("sm")]: {
      border: "solid 1px lightgrey",
      borderBottom: `solid 5px ${theme.palette.primary.main}`,
      borderRadius: 5,
    },
  },
  box: {
    [theme.breakpoints.up("xs")]: {
      marginTop: -30,
    },
    [theme.breakpoints.up("md")]: {
      marginTop: -80,
    },
    [theme.breakpoints.up("lg")]: {
      marginTop: -110,
    },
    [theme.breakpoints.up("xl")]: {
      marginTop: -150,
    },
    marginBottom: 50,
  },
}));

const LoginView = () => {
  const classes = useStyles();
  const brand = getBrandFromUrl();
  const service = getServiceFromUrl();
  const country = getCountryFromURL().toLowerCase();
  const otherService = brand =="Dollar" || brand == "Thrifty" ? <div></div> : <OtherServices brand={brand} country={country} />

  return (
    <Page
      className={classes.root}
      title="Login - My Journey Portal"
      style={{ background: "white", textAlign: "center" }}
    >
      <img
        src={
          brand === "Ace"
            ? constants.ACE_LOGIN_BANNER
            : brand === "Firefly"
            ? constants.FIREFLY_LOGIN_BANNER
            : brand === "Dollar" ? service === "MJP" ? constants.DOLLAR_LOGIN_BANNER : constants.DOLLAR_ONLINE_CHECKIN_BANNER
            : brand === "Thrifty" ? service === "MJP" ? constants.THRIFTY_LOGIN_BANNER : constants.THRIFTY_ONLINE_CHECKIN_BANNER
            : service === "MJP" ? constants.HERTZ_LOGIN_BANNER : constants.HERTZ_ONLINE_CHECKIN_LOGIN_BANNER
        }
        width="100%"
      />
      <Box display="flex" flexDirection="row" justifyContent="center" className={classes.box}>
        <Container maxWidth="sm" className={classes.container}>
          <LoginForm brand={brand} />
          <Divider style={{ marginTop: 50, marginBottom: 40 }} />
          {otherService}
          <FooterSmall brand={brand} />
        </Container>
      </Box>
    </Page>
  );
};

export default LoginView;
